export const PASSWORD_POLICY_TEXT = 'Use at least 8 characters with uppercase, lowercase, and a number.';

export const getPasswordPolicyError = (password: string): string => {
  if (password.length < 8) return 'Password must be at least 8 characters long.';
  if (!/[A-Z]/.test(password)) return 'Password must include at least one uppercase letter.';
  if (!/[a-z]/.test(password)) return 'Password must include at least one lowercase letter.';
  if (!/\d/.test(password)) return 'Password must include at least one number.';
  return '';
};

export const getPasswordStrength = (password: string): { score: number; label: string } => {
  if (!password) return { score: 0, label: PASSWORD_POLICY_TEXT };

  const score = [
    password.length >= 8,
    /[A-Z]/.test(password),
    /[a-z]/.test(password),
    /\d/.test(password),
  ].filter(Boolean).length;

  if (score <= 1) return { score, label: 'Weak password' };
  if (score <= 3) return { score, label: 'Almost there' };
  return { score, label: 'Strong password' };
};
